import React from 'react'
import { Switch } from 'antd'

import InputNumber from '../../input-number'
import InputInteger from '../../input-integer'
import InputCheckbox from '../../Input-checkbox'
import InputDateTime from '../../input-date-time'
import InputDate from '../../input-date'
import InputTime from '../../input-time'
import InputTimeRange from '../../input-time-range'
import InputDateRange from '../../input-date-range'
import InputPhone from '../../input-phone'
import InputPhoneClient from '../../input-phone-client'
import InputText from '../../input-text'
import ArrayMultiField from '../../array-multi-field'
import SelectFromEnum from '../../select-from-enum'
import SelectFromEnumAsync from '../../select-from-enum-async'
import CollectionSelect from 'src/react-app/connectors/json-form-select-object'
import CollectionSelectTypeAdvertising from 'src/react-app/connectors/json-form-select-object-type-advertising'
import SelectFromRoles from 'src/react-app/connectors/select-from-roles'
import UserSelect from '../../app-user-select'
import AdaptorObjectField from './adaptor-field'
import FileS3 from 'src/react-app/connectors/multi-file-s3-json-form/multi-file-s3-json-form'
import UploadFilesS3 from 'src/react-app/connectors/multi-file-s3-new/multi-file-s3-new'
import SelectFromOrganizationTypes from 'src/react-app/connectors/select-from-organization-types'
import SelectFromUser from 'src/react-app/connectors/select-from-user'
import SelectFromOrganizationInn from 'src/react-app/connectors/select-from-organization-inn'
import SelectFromUsers from 'src/react-app/connectors/select-from-users'
import SelectFromOrganizations from 'src/react-app/connectors/select-from-organizations'
import SelectFromOrganizationsV2 from 'src/react-app/connectors/select-from-organizations-v2'
import ContractOrderPrice from 'src/react-app/connectors/contract-order-price'
import ContractOrderPricePay from 'src/react-app/connectors/contract-order-price-pay'
import InputRadioGroup from 'src/react-app/components/input-radio-group'
import InputTextAddress from 'src/react-app/components/input-text-address'
import InputTextDadata from 'src/react-app/components/input-text-dadata'
import SelectFromRegions from 'src/react-app/connectors/select-from-regions'
import SelectFromCity from 'src/react-app/connectors/select-from-city'
import MultiSelect from 'src/react-app/connectors/multi-select'
import InputPassword from 'src/react-app/components/input-password'
import InputAdditionalContacts from '../../input-additional-contacts'
import { InputShippingDate } from '../../input-shipping-date/ui/input-shipping-date'
import { DisabledFieldRenderer } from './disabled-field-renderer'
import { InputHrEmployeeCompliance } from '../../../connectors/hr-employee-compliance'

export function getInputNode(value: any, UISchema?: any, data?: unknown) {
  if (value?.type === 'string') {
    if (value?.view?.name === 'hr-employee-compliance') {
      return <InputHrEmployeeCompliance schema={value} />
    }
    if (value?.view?.name === 'input-radio-group') {
      return <InputRadioGroup schema={value} UISchema={UISchema} />
    }
    if (value?.view?.name === 'input-text-address') {
      return <InputTextAddress schema={value} UISchema={UISchema} />
    }
    if (value?.view?.name === 'input-text-dadata') {
      return <InputTextDadata schema={value} UISchema={UISchema} />
    }
    if (value?.format === 'date-time') {
      return <InputDateTime UISchema={UISchema} value={data} />
    }
    if (value?.format === 'date') {
      return <InputDate UISchema={UISchema} schema={value} value={data} onChange={() => {}} />
    }
    if (value?.format === 'time') {
      return <InputTime UISchema={UISchema} value={data} />
    }
    if (value?.format === 'phone') {
      return <InputPhone UISchema={UISchema} />
    }
    if (value?.format === 'phone-client') {
      return <InputPhoneClient UISchema={UISchema} />
    }
    if (value?.format === 'additional-contacts') {
      return <InputAdditionalContacts value={value} />
    }
    if (value?.format === 'platform-collection') {
      return <CollectionSelect schema={value} UISchema={UISchema} />
    }
    if (value?.format === 'platform-user') {
      return <UserSelect schema={value} UISchema={UISchema} />
    }
    if (value?.format === 'file-s3') {
      if (value?.options?.isNewUrl) {
        return <UploadFilesS3 value={data} schema={value} UISchema={UISchema} />
      }
      return <FileS3 value={data} onChange={() => {}} schema={value} UISchema={UISchema} />
    }
    if (value?.format === 'time-range') {
      return <InputTimeRange schema={value} UISchema={UISchema} value={data} />
    }
    if (value?.format === 'date-range') {
      return <InputDateRange schema={value} UISchema={UISchema} value={data} />
    }
    if (value?.view?.name === 'select-from-enum') {
      return <SelectFromEnum schema={value} UISchema={UISchema} />
    }
    if (value?.view?.name === 'select-from-enum-async') {
      return <SelectFromEnumAsync schema={value} UISchema={UISchema} />
    }
    if (value?.view?.name === 'password') {
      return <InputPassword schema={value} UISchema={UISchema} />
    }
    if (value?.view?.name === 'input-shipping-date') {
      return <InputShippingDate value={data} UISchema={UISchema} />
    }
    return <InputText schema={value} UISchema={UISchema} />
  }
  if (value?.type === 'pointer') {
    if (value?.view?.name === 'select-from-organization-types') {
      return <SelectFromOrganizationTypes UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-organizations') {
      return <SelectFromOrganizations UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-organizations-v2') {
      return <SelectFromOrganizationsV2 UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-regions') {
      return <SelectFromRegions UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-city') {
      return <SelectFromCity UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-user') {
      return <SelectFromUser UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-users') {
      return <SelectFromUsers UISchema={UISchema} />
    } else if (value?.view?.name === 'select-from-organization-inn') {
      return <SelectFromOrganizationInn UISchema={UISchema} />
    } else if (value?.view?.name === 'type-advertising') {
      return <CollectionSelectTypeAdvertising schema={value} UISchema={UISchema} />
    } else {
      return <MultiSelect schema={value} value={data} UISchema={UISchema} />
    }
  }
  if (value?.type === 'boolean') {
    return <InputCheckbox UISchema={UISchema} />
  }
  if (value?.type === 'number') {
    if (value?.view?.name === 'contract-order-price') {
      return <ContractOrderPrice UISchema={UISchema} />
    }
    if (value?.view?.name === 'contract-order-price-pay') {
      return <ContractOrderPricePay UISchema={UISchema} />
    }
    return <InputNumber UISchema={UISchema} />
  }
  if (value?.type === 'integer') {
    return <InputInteger UISchema={UISchema} />
  }
  if (value?.type === 'array') {
    if (value?.view?.name === 'select-from-roles') {
      return <SelectFromRoles schema={value} UISchema={UISchema} />
    }
    return <ArrayMultiField schema={value} UISchema={UISchema} />
  }
  if (value?.type === 'object') {
    return <AdaptorObjectField schema={value} />
  }
  if (value?.type === 'devider') {
    return value?.content
  }
  if (value?.type === 'switch') {
    return <Switch onChange={() => {}} defaultChecked={!!data} />
  }
  return null
}

export function getInputNodeCustom(schema: any, UISchema?: any, data?: unknown) {
  if (UISchema?.render) {
    return <UISchema.render schema={schema} UISchema={UISchema} />
  }
  if (UISchema?.options?.disabled) {
    return <DisabledFieldRenderer value={data} schema={schema} UISchema={UISchema} />
  }
  return getInputNode(schema, UISchema, data)
}
